import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import API_URL from "../../config/ApiUrl";

export const getTransporters = createAsyncThunk(
  "transporter/getTransporters",
  async (payload, { rejectWithValue }) => {
    try {
      const params = new URLSearchParams();
      Object.entries(payload).forEach(([key, value]) => {
        if (value !== null && value !== undefined && value !== "") {
          if (Array.isArray(value)) {
            value.forEach((v) => params.append(key, v));
          } else {
            params.append(key, value);
          }
        }
      });
      const { data } = await axios.get(
        `${API_URL.TRANSPORTER.SLUG}?${params}`,
      );
      return data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  },
);

export const createTransporter = createAsyncThunk(
  "transporter/createTransporter",
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        `${API_URL.TRANSPORTER.SLUG}`,
        payload,
      );
      return data.data;
    } catch (error) {
      return rejectWithValue(error?.data || error);
    }
  },
);

export const editTransporter = createAsyncThunk(
  "transporter/editTransporter",
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await axios.put(
        `${API_URL.TRANSPORTER.SLUG}`,
        payload,
      );
      return data.data;
    } catch (error) {
      return rejectWithValue(error?.data || error);
    }
  },
);

export const deleteTransporter = createAsyncThunk(
  "transporter/deleteTransporter",
  async (id, { rejectWithValue }) => {
    try {
      const { data } = await axios.delete(
        `${API_URL.TRANSPORTER.SLUG}/${id}`,
      );
      return data.data;
    } catch (error) {
      return rejectWithValue(error?.data || error);
    }
  },
);

const initialState = {
  transporter_list: [],
  current_values: null,
  active_payload: null,
};

const transporterSlice = createSlice({
  name: "transporter",
  initialState,
  reducers: {
    setCurrentValues: (state, action) => {
      state.current_values = action.payload;
    },
    setActivePayload: (state, action) => {
      state.active_payload = action.payload;
    },
    resetCurrentValue: (state) => {
      state.current_values = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getTransporters.fulfilled, (state, action) => {
      state.transporter_list = action.payload.data.list;
    });
  },
});

export const { setCurrentValues, setActivePayload, resetCurrentValue } =
  transporterSlice.actions;
export default transporterSlice.reducer;
